"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetch = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
function validateFetchApiExists() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!(window === null || window === void 0 ? void 0 : window.fetch)) return [3 /*break*/, 2];
                    return [4 /*yield*/, require("abortcontroller-polyfill/dist/polyfill-patch-fetch")];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
/**
 * Sets up and executes fetch request
 * @param options Settings that change how the fetch executes. Some options are required.
 * @param options.url Url of the request
 * @param options.method Request method e.g. "POST", "GET".
 * @param options.timeoutValue The maximum amount of time, in milliseconds, before the fetch request aborts and rejects with an AbortError.
 * @param [options.body] Request body.
 * @param [options.errorsWithJsonResponse=[]] Non-200 Status codes for which the request returns a JSON.
 * @param [options.headers={"Content-Type": "application/json"}] Headers for the request.
 * @returns Javascript Object that was returned from the request on success. Rejected promise on failure.
 */
function Fetch(options) {
    return __awaiter(this, void 0, void 0, function () {
        var url, method, timeoutValue, body, _a, errorsWithJsonResponse, _b, headers, controller, reqOptions, responseData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = options.url, method = options.method, timeoutValue = options.timeoutValue, body = options.body, _a = options.errorsWithJsonResponse, errorsWithJsonResponse = _a === void 0 ? [] : _a, _b = options.headers, headers = _b === void 0 ? { "Content-Type": "application/json" } : _b;
                    if (!(typeof window !== "undefined")) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateFetchApiExists()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    controller = new AbortController();
                    setTimeout(function () {
                        controller.abort();
                    }, timeoutValue);
                    reqOptions = {
                        signal: controller.signal,
                        method: method,
                        headers: headers,
                    };
                    if (body) {
                        reqOptions.body = JSON.stringify(body);
                    }
                    responseData = (0, cross_fetch_1.default)(url, reqOptions)
                        .then(function (response) {
                        if (response.ok ||
                            (errorsWithJsonResponse &&
                                errorsWithJsonResponse.includes(response.status))) {
                            return response.json();
                        }
                        var err = {
                            error: response.statusText,
                            description: "client-platform-network: ".concat(method, ": ").concat(url, " failed. Status: ").concat(response.status, ", ").concat(response.statusText),
                        };
                        return Promise.reject(err);
                    })
                        .catch(function (errorResult) {
                        // network and abort errors have standard message fields
                        // errors from the v5 api have error and description fields
                        var error = errorResult.error || errorResult;
                        var description = errorResult.description || errorResult.message;
                        var errResponse = {
                            error: error,
                            description: description,
                        };
                        return Promise.reject(errResponse);
                    });
                    return [2 /*return*/, responseData];
            }
        });
    });
}
exports.Fetch = Fetch;
